import React, { Component } from "react";
import classes from "./MediaCard.module.css";

import MediaPDFIcon from "../../../assets/img/MediaPDFIcon.svg";
import MediaPPTIcon from "../../../assets/img/MediaPPTIcon.svg";
import MediaDOCIcon from "../../../assets/img/MediaDOCIcon.svg";
import MediaXLSIcon from "../../../assets/img/MediaXLSIcon.svg";
import MediaIMAGEIcon from "../../../assets/img/MediaIMAGEIcon.svg";
import MediaVIDEOIcon from "../../../assets/img/MediaVIDEOIcon.svg";
import MediaCardCheckIcon from "../../../assets/img/MediaCheck.svg";
import MediaCardCloudIcon from "../../../assets/img/MediaCloud.svg";
import Tooltip from "@material-ui/core/Tooltip";
// import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withTranslation } from 'react-i18next';

class MediaCard extends Component {
  state = {
    mediaCardMenu: null,
  };
  handleMenuClick = (event) => {
    this.setState({ mediaCardMenu: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ mediaCardMenu: null });
  };
  render() {
    const { t } = this.props;
    let fileIconType = "";
    switch (this.props.mediaDocInfo.fileIconType) {
      case "IMAGE":
        fileIconType = MediaIMAGEIcon;
        break;
      case "VIDEO":
        fileIconType = MediaVIDEOIcon;
        break;
      case "DOC":
        fileIconType = MediaDOCIcon;
        break;
      case "PPT":
        fileIconType = MediaPPTIcon;
        break;
      case "XLS":
        fileIconType = MediaXLSIcon;
        break;
      case "PDF":
        fileIconType = MediaPDFIcon;
        break;
      default:
        fileIconType = MediaPDFIcon;
        break;
    }
    return (
      <>
        <div
          className={classes.Card}
          onClick={() => {
            this.props.selectedMedia(this.props.mediaDocInfo);
          }}
        >
          {/* Card Image */}
          <div className={classes.CardImageWrapper}>
            <img
              src={fileIconType}
              style={{ height: "7.1vw" }}
              alt="Lesson-Plan-Img"
            />
            <img
              src={
                this.props.mediaDocInfo.isPublished
                  ? MediaCardCheckIcon
                  : MediaCardCloudIcon
              }
              alt="Checked"
              style={{ position: "absolute", right: "1vw", top: "-1px" }}
            />
          </div>
          {/* Card Description */}
          <div className={classes.CardDescription}>
            <Tooltip title={this.props.mediaDocInfo.name}>
              <p
                className={[classes.CardDescriptionText, "TextDarkGrey"].join(
                  " "
                )}
              >
                {this.props.mediaDocInfo.name}
              </p>
            </Tooltip>

            {/* <div
              className={[classes.CardDescriptionOptions, "TextDarkGrey"].join(
                " "
              )}
              aria-controls="media-card-menu"
              aria-haspopup="true"
              onClick={this.handleMenuClick}
            >
              <MoreVertIcon />
            </div> */}
          </div>
        </div>

        {/* Menu  */}
        <Menu
          id="media-card-menu"
          anchorEl={this.state.mediaCardMenu}
          keepMounted
          open={Boolean(this.state.mediaCardMenu)}
          onClose={this.handleMenuClose}
        >
          <MenuItem onClick={this.handleMenuClose}>{t("Open")}</MenuItem>
          <MenuItem onClick={this.handleMenuClose}>{t("Delete")}</MenuItem>
        </Menu>
      </>
    );
  }
}

export default withTranslation()(MediaCard);
